import React, {useContext, useState} from "react";
import AiAvatar from "./AiAvatar/AiAvatar.tsx";
import PlayAudio from "./PlayAudio/PlayAudio.tsx";
import voiceMapping from "../../../../../Utils/IdMappings/VoiceMapping.ts";
import {GlobalContext} from "../../../../../App.tsx";
import {MessageBottomContainerContext} from "../../Message.tsx";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";
import {handleAudioClick} from "../../../../../Utils/misc/playAudio.ts";
import OptionsMenu from "../Shared/OptionsMenu/OptionsMenu.tsx";
import Flag from "../Shared/Icons/Flag.tsx";
import {toggleMessageImportance} from "../../../../../Utils/messageObject/messageObjectUtils.ts";
import copyButton from "../../../../../assets/copyButton.svg";

interface AiContainerProps {}

const AiContainer: React.FC<AiContainerProps> = ({ }) => {
    const {miscMidRenderRefs, websocketRef, setupWebsocketHelper} = useContext(GlobalContext);
    const {group, isLast} = useContext(MessageBottomContainerContext);
    const { setMessages } = useContext(GlobalContext);

    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { importantMessageIds, conversationId } = dynamicStateObj;
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { isIncognito } = settingsObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const updateImportantMessageIds = useAppStore((state: any) => state.updateImportantMessageIds);
    const [isCopied, setIsCopied] = useState(false);

    const messageId = group.messages[0].id;
    const isInProgress = group.messages[group.messages.length - 1].message.isInProgress || (isLast && dynamicStateObj.elementsInProgress.size > 0);

    const computeAiTextContents = () => {
        const textMessages = group.messages.map(({ message }: { message: any }) => {
            if (message.role === "assistant") {
                return message.content
                    .filter((item: any) => item.type === "text")
                    .map((item: any) => item.text);
            }
            return [];
        });

        return textMessages.flat().join('\n');
    };

    const handleCopyClick = () => {
        if (isInProgress) return;

        navigator.clipboard.writeText(computeAiTextContents()).then(() => {
            console.log("Text copied to clipboard");
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    };

    const menuOptions: any = [
        {
            icon: <Flag color={"yellow"} />,
            label: "Important",
            onClick: () => {
                toggleMessageImportance(user, isIncognito, conversationId, messageId, !importantMessageIds.has(messageId), updateImportantMessageIds, setMessages);
            },
            tooltip: importantMessageIds.has(messageId) ? "Unmark message as important" : "Mark message as important"
        },
        {
            icon: <img src={copyButton} alt="Copy" className="h-4 w-4 invert-0 dark:invert" />,
            label: isCopied ? "Copied!" : "Copy",
            onClick: handleCopyClick,
            tooltip: "Copy raw text",
            isDisabled: isInProgress
        }
    ];

    if (environmentObj.environment.includes("android")) {
        menuOptions.push({
            label: "Report",
            onClick: () => {
                setDynamicStateObj({ visiblePopup: "report" });
            },
            tooltip: "Report this message",
            icon: <Flag color="red" />
        });
    }

    const handleAudioClickWrapper = () => {
        const aiTextContents = computeAiTextContents();
        handleAudioClick(
            websocketRef,
            group.index,
            aiTextContents,
            setDynamicStateObj,
            miscMidRenderRefs,
            voiceMapping[settingsObj.voice],
            setupWebsocketHelper
        );
    };
    return (
        <div className="flex space-x-2.5 items-center">
            <AiAvatar />
            <PlayAudio
                isPlaying={dynamicStateObj.playingId === group.index}
                handleAudioClickHelper={handleAudioClickWrapper}
                isInProgress={isInProgress}
            />
            <div className="-ml-2">
                <OptionsMenu options={menuOptions} align="left"/>
            </div>
        </div>
    )
};

export default AiContainer;